/**
 * @file PortfolioAllocationFull.jsx
 * @description Main application interface with role-specific features
 * 
 * @section Responsibilities
 * - Manage role-based views
 * - Handle data aggregation
 * - Control real-time updates
 * - Manage user preferences
 * 
 * @section Dependencies
 * - Role Management: Access control
 * - Data Services: Information handling
 * - State Management: Global state
 * 
 * @section Integration Points
 * - Data API: Information retrieval
 * - Role System: Access control
 * - Notification System: Real-time updates
 * 
 * @section State Management
 * - dashboardData: Aggregated information
 * - loadingState: Data fetching
 * - errorState: Error handling
 * 
 * @section Events
 * - onDataUpdate: Data changes
 * - onError: Error handling
 * - onPreferenceChange: Settings updates
 * 
 * @section Props
 * @prop {String} userRole - Current user role
 * @prop {Object} permissions - User permissions
 */

import React from 'react'
import Widget from '../Widget'
import AssetsPercentageList from '../../../../components/dashboard/AssetsPercentageList'

function PortfolioAllocationFull({ width }) {
    const assetList = [
        { name: "Fund 1", slug: "Fund-1", value: 15, switch: true, status: "active" },
        { name: "Fund 2", slug: "Fund-2", value: 0, switch: false, status: "inactive" },
        { name: "Fund 3", slug: "Fund-3", value: 25, switch: true, status: "active" },
        { name: "Fund 4", slug: "Fund-4", value: 30, switch: true, status: "active" },
        { name: "Fund 5", slug: "Fund-5", value: 15, switch: true, status: "active" },
        { name: "Fund 6", slug: "Fund-6", value: 15, switch: true, status: "active" },
    ]

    return (
        <Widget name={"portfolio-allocation-full"} width={width}>
            <div className="heading">
                <h1 className="title">Portfolio Allocation</h1>
            </div>
            <p className="description">
                Diversify your portfolio, use the arrows to adjust the percentage of an asset within your portfolio, reach 100% to save changes.
            </p>
            <AssetsPercentageList data={assetList} />
        </Widget>
    )
}

export default PortfolioAllocationFull